module.exports = __webpack_public_path__ + "static/media/bgTopPosts.2ce1ab3b.png";